import { render, staticRenderFns } from "./OriginMove.vue?vue&type=template&id=89f53bd6&"
import script from "./OriginMove.vue?vue&type=script&lang=js&"
export * from "./OriginMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports